import React from "react"
import type { SiteSetting } from "./siteSettingsTypes"

export default function SiteSettingsGenericTab(props: {
  setting: SiteSetting | undefined
  onToggle: (id: string) => void
}) {
  const { setting, onToggle } = props

  if (!setting) {
    return (
      <div className="mb-8 p-6 bg-gray-950 border border-gray-800 text-gray-400">此設定項目不存在或已被移除</div>
    )
  }

  return (
    <div className="mb-8">
      <div className="bg-gray-950 border border-gray-800 p-6 hover:border-gray-700 transition-colors">
        <div className="flex items-start justify-between gap-6">
          <div className="flex-1">
            <h3 className="text-xl font-light tracking-wide text-gray-100 mb-2">{setting.displayName}</h3>
            <p className="text-sm text-gray-400 mb-3">{setting.description}</p>
            <div className="flex items-center gap-4 text-xs text-gray-500">
              <span>識別碼: {setting.settingKey}</span>
              <span>最後更新: {new Date(setting.updatedAt).toLocaleString("zh-TW")}</span>
            </div>
          </div>

          <div className="flex flex-col items-end gap-2">
            <button
              onClick={() => onToggle(setting._id)}
              className={`relative inline-flex h-8 w-16 items-center rounded-full transition-colors ${
                setting.enabled ? "bg-green-600" : "bg-gray-700"
              }`}
              aria-label={`切換 ${setting.displayName}`}
            >
              <span
                className={`inline-block h-6 w-6 transform rounded-full bg-white transition-transform ${
                  setting.enabled ? "translate-x-9" : "translate-x-1"
                }`}
              />
            </button>
            <span className={`text-sm font-medium ${setting.enabled ? "text-green-400" : "text-gray-500"}`}>
              {setting.enabled ? "已啟用" : "已停用"}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
